module.exports = __webpack_public_path__ + "static/media/behind.5d85749b.svg";